module.exports = __webpack_public_path__ + "static/media/wrong.c0e356d0.svg";